export const MODELS_API_PATH = '/api/models';
export const MODELS_PATH = '/models';
export const API_REQUEST_KEY = 'MODELS';
export const MODELS_PATH_NEW = '/models/new';
export const MODELS_PATH_EDIT = '/models/:id/edit';
export const MODELS_PATH_BY_ID = `${MODELS_PATH}/:id`;
